/**
 * Highest page offset the snapshot accepts. Bounded so a crafted offset cannot make
 * Postgres walk an unbounded result set, and exported so the client stops offering another
 * page at the same boundary instead of walking into a 400.
 */
export const DEAD_STOCK_MAX_OFFSET = 100_000;
